import React, {forwardRef} from "react";
import css from "./PageContainer.module.scss";

const PageContainer = forwardRef(({
  children,
  className = '',
  style,
  ...props
}, ref) => (
  <div
    ref={ref}
    className={`${css.pageContainer} ${className}`}
    style={{...style}}
    {...props}
  >
    {children}
  </div>
));

PageContainer.displayName = "PageContainer";

export default PageContainer;
